<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="13" viewBox="0 0 9 13">
    <g id="Group_28865" data-name="Group 28865" transform="translate(-1378 -334)">
      <path id="Polygon_7" data-name="Polygon 7" d="M4.5,0,9,5H0Z" transform="translate(1378 334)" />
    </g>
  </svg>
</template>
